(function () {
    'use strict';

    angular
        .module('app.audit')
        .controller('AuditDetailsController', AuditDetailsController);

    /* @ngInject */
    function AuditDetailsController(logger,
        auditService,
        $uibModalInstance,
        auditLog,
        moment,
        $filter,
        $q) {

        var vm = this;
        vm.title = 'Event Details';
        vm.auditLog = auditLog;        
       
        vm.reset = reset;
        vm.details = [];

        // Smart Table
        vm.tableConfig = configureTableActions();

        // DI / IOC / unit testing / mocking
        vm.auditService = auditService;

        //public methods
        vm.mapAuditDetails = mapAuditDetails;

        activate();

        function activate() {     
            logger.info('Activated Audit log detail View');
        }      

        function reset() {
            $uibModalInstance.dismiss('cancel');
        }      

        function configureTableActions() {
            var tableConfig = auditService.getDetailTableConfig();           
            return tableConfig;
        }

        function mapAuditDetails() {
            return $q.when(auditLog.AuditLogDetails);
        }
    }
})();
